import React from 'react';

export const Filters = () => (
  <svg
    width="19px"
    height="15px"
    viewBox="0 0 19 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="matchr-filters"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="05_matcher_ui-version_02"
        transform="translate(-272.000000, -49.000000)"
        stroke="#3C3C3C"
      >
        <g id="Filters" transform="translate(272.000000, 49.000000)">
          <g id="Group" transform="translate(0.000000, 0.000000)">
            <circle id="Oval" cx="12.9411765" cy="3.52941176" r="3.02941176" />
            <circle id="Oval" cx="5.88235294" cy="10.5882353" r="3.02941176" />
            <line x1="0" y1="3.52941176" x2="10" y2="3.52941176" id="Line" />
            <line
              x1="9.11764706"
              y1="10.5882353"
              x2="18.8235294"
              y2="10.5882353"
              id="Line"
            />
            <line
              x1="0"
              y1="10.5882353"
              x2="2.94117647"
              y2="10.5882353"
              id="Line-2"
            />
            <line
              x1="15.8823529"
              y1="3.52941176"
              x2="18.8235294"
              y2="3.52941176"
              id="Line-3"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Filters;
